import { type HTMLAttributes, type Ref } from 'react';
import clsx from 'clsx';

import { useFontReady } from '../../utils/useFontReady';
import { LoadingIndicator } from '../loading-indicator/LoadingIndicator';

import styles from './googleFontIcon.module.scss';

const FONT_SHORTHAND = '1em "Material Symbols Outlined Variable"';

type GoogleFontIconProps = {
  className?: string;
  name: string;
  title?: string;
  small?: boolean;
  solid?: boolean;
  /** Renders the icon inside a primary pill badge. */
  badge?: boolean;
  'data-testid'?: string;
  ref?: Ref<HTMLSpanElement>;
} & HTMLAttributes<HTMLSpanElement>;

function GoogleFontIcon({
  className,
  name,
  title,
  small,
  solid,
  badge,
  ref,
  ...props
}: GoogleFontIconProps) {
  const ready = useFontReady(FONT_SHORTHAND);

  return (
    <span
      ref={ref}
      {...props}
      data-testid={props['data-testid'] ?? `google-font-icon-${name}`}
      className={clsx(
        'portal-icon',
        styles['root'],
        solid && styles['root--solid'],
        small && styles['root--small'],
        badge && styles['root--badge'],
        className
      )}
      title={title}
    >
      {ready ? name : <LoadingIndicator size="1em" />}
    </span>
  );
}

export { GoogleFontIcon };
